import './theme.d'
import { createTheme } from '@mui/material/styles'
import palette from './palette'
import DrawerThemeStyles from './componentStyles/Drawer.theme.styles'

const theme = createTheme({
	palette,
	typography: {
		fontFamily: ['Sora'] as any,
		h1: {
			fontFamily: '"Eczar", serif',
			fontSize: '40px',
			fontWeight: '500',
			color: palette.text.darkBlue,
		},
		h3: {
			fontSize: '14px',
			fontWeight: '600',
			color: palette.text.darkGrey,
		},
		h6: {
			fontFamily: "'Sora', sans-serif",
		},
		button: {
			fontWeight: 500, // Adjust weight for buttons
			fontSize: '14pt', // Adjust size for buttons
			textTransform: 'none',
		},
	},

	components: {
		MuiTableCell: {
			styleOverrides: {
				root: {
					// Apply the theme's primary text color to all table cells
					color: '#111315',
				},
			},
		},
		MuiDrawer: {
			styleOverrides: {
				root: DrawerThemeStyles as any,
			},
		},
		MuiListItemIcon: {
			styleOverrides: {
				root: {
					div: {
						backgroundColor: 'red',
					},
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: palette.brand.main,
					},
					':hover .MuiOutlinedInput-notchedOutline': {
						borderColor: palette.brand.main, // Optional hover color
					},
					'.MuiInputBase-root': {
						borderRadius: '10px',
						'&.Mui-focused.MuiOutlinedInput-notchedOutline': {
							borderColor: palette.brand.main,
						},
					},
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				root: {
					'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: palette.brand.main,
					},
					'&:hover .MuiOutlinedInput-notchedOutline': {
						borderColor: palette.brand.main, // Optional hover color
					},
					borderRadius: '10px',
					'.MuiSelect-select[aria-expanded="true"] .MuiOutlinedInput-notchedOutline': {
						borderColor: palette.brand.main,
					},
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: '8px',
					fontSize: '14px',
				},
			},
		},
	},
})
export default theme
